document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('formulario-bf');
  var bar = document.querySelector('[data-lbf-sticky-cta]');

  if (form && bar && typeof IntersectionObserver !== 'undefined') {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px 0px 96px 0px' }
    );

    observer.observe(form);
  }
});
